import faker from 'faker';
import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { set, sub, formatDistanceToNow } from 'date-fns';
import { Icon } from '@iconify/react';
import bellFill from '@iconify/icons-eva/bell-fill';
import clockFill from '@iconify/icons-eva/clock-fill';
import doneAllFill from '@iconify/icons-eva/done-all-fill';
// material
import { alpha } from '@material-ui/core/styles';
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  ListItem,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  CircularProgress,
  TablePagination
} from '@material-ui/core';
// utils
import { mockImgAvatar } from '../../utils/mockImages';
// components
import Scrollbar from '../../components/Scrollbar';
import MenuPopover from '../../components/MenuPopover';
import { MIconButton } from '../../components/@material-extend';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import moment from 'moment';
import { getAgoString } from 'src/common/Helper';

// ----------------------------------------------------------------------

const NOTIFICATIONS = [
  {
    id: faker.datatype.uuid(),
    title: 'Your order is placed',
    description: 'waiting for shipping',
    avatar: null,
    type: 'order_placed',
    createdAt: set(new Date(), { hours: 10, minutes: 30 }),
    isUnRead: true
  },
  {
    id: faker.datatype.uuid(),
    title: faker.name.findName(),
    description: 'answered to your comment on the Minimal',
    avatar: mockImgAvatar(2),
    type: 'friend_interactive',
    createdAt: sub(new Date(), { hours: 3, minutes: 30 }),
    isUnRead: true
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new message',
    description: '5 unread messages',
    avatar: null,
    type: 'chat_message',
    createdAt: sub(new Date(), { days: 1, hours: 3, minutes: 30 }),
    isUnRead: false
  },
  {
    id: faker.datatype.uuid(),
    title: 'You have new mail',
    description: 'sent from Guido Padberg',
    avatar: null,
    type: 'mail',
    createdAt: sub(new Date(), { days: 2, hours: 3, minutes: 30 }),
    isUnRead: false
  },
  {
    id: faker.datatype.uuid(),
    title: 'Delivery processing',
    description: 'Your order is being shipped',
    avatar: null,
    type: 'order_shipped',
    createdAt: sub(new Date(), { days: 3, hours: 3, minutes: 30 }),
    isUnRead: false
  }
];
const ActivityComponent = ({ activity }) => {
  return (
    <Typography
      variant="body1"
      component="div"
      sx={{ '& strong': { fontWeight: 'bold' } }}
      dangerouslySetInnerHTML={{ __html: activity }}
    />
  );
};
function renderContent(notification) {

  const title = (
    <Typography variant="subtitle2">
      {notification?.title}
      <Typography component="span" variant="body2" >
        {/* &nbsp; {noCase(notification.description)} */}
        <ActivityComponent activity={notification.message} />
      </Typography>
    </Typography>
  );

  if (notification.type === 'order_placed') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_package.svg" />,
      title
    };
  }
  if (notification.type === 'order_shipped') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_shipping.svg" />,
      title
    };
  }
  if (notification.type === 'mail') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_mail.svg" />,
      title
    };
  }
  if (notification.type === 'chat_message') {
    return {
      avatar: <img alt={notification.title} src="/static/icons/ic_notification_chat.svg" />,
      title
    };
  }
  return {
    avatar: <img alt={notification.title} src={notification.avatar} />,
    title
  };
}

NotificationItem.propTypes = {
  notification: PropTypes.object.isRequired
};

function NotificationItem({ notification }) {

  const { profile_pic, title,url } = renderContent(notification);

  return (
    <ListItem
      button
      // to="#"
      disableGutters
      // component={RouterLink}
      sx={{
        py: 1.5,
        px: 2.5,
        mt: '1px',
        ...(notification.isUnRead && {
          bgcolor: 'action.selected'
        })
      }}
    >
      <ListItemAvatar>
        <Avatar src={profile_pic} sx={{ bgcolor: 'background.neutral' }}>{profile_pic}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={title}
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled'
            }}
          >
            <Box component={Icon} icon={clockFill} sx={{ mr: 0.5, width: 16, height: 16 }} />
           
            {getAgoString(notification?.timestamp)}
            
          </Typography>
        }
      />
    </ListItem>
  );
}

export default function NotificationsPopover() {
  const user = localStorage.getItem('user')
  const userData = JSON.parse(user)
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [notificationCount,setNotificationCount] = useState(null)
  const [notifications,setNotifications] = useState(null)
  const [currentPage, setCurrentPage] = useState(0) // TablePagination uses 0-based indexing
  const [rowsPerPage, setRowsPerPage] = useState(6) // Fixed at 6 items per page
  const [totalCount, setTotalCount] = useState(0) // Total number of notifications
  const [loading, setLoading] = useState(false)
  
  // const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const totalUnRead = notifications?.filter((item) => item.isUnRead === true).length;
  
  // BACKUP: Original fetchNotification function without pagination
  // const fetchNotification =async()=>{
  //   // let res = []
  //   let res = await axios.post(`${REST_API_END_POINT}notification/fetch-all-notifications`,{userId:userData.user_id})
  //   setNotifications(res?.data?.notifications)
  //   setNotificationCount(res?.data["notificationCount"]["noti_count"])
  // }
  
  // NEW: fetchNotification with pagination support for TablePagination
  const fetchNotification = async (page = 0, append = false) => {
    setLoading(true)
    try {
      // Convert 0-based page to 1-based for backend
      const backendPage = page + 1
      
      let res = await axios.post(`${REST_API_END_POINT}notification/fetch-all-notifications`, {
        userId: userData.user_id,
        page: backendPage
      })
      
      if (append && notifications) {
        // Append new notifications to existing ones
        setNotifications([...notifications, ...res?.data?.notifications])
      } else {
        // Replace notifications (first page or refresh)
        setNotifications(res?.data?.notifications)
      }
      
      setNotificationCount(res?.data["notificationCount"]["noti_count"])
      setCurrentPage(page)
      
      // Use totalCount from backend response
      setTotalCount(res?.data?.totalCount || 0)
    } catch (error) {
      console.error('Error fetching notifications:', error)
    } finally {
      setLoading(false)
    }
  }
  
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage)
    fetchNotification(newPage, false) // Don't append, replace current notifications
  }
  
  const handleChangeRowsPerPage = (event) => {
    // Keep rowsPerPage fixed at 6 as per requirement
    setRowsPerPage(6)
  }
  useEffect(() => {
    fetchNotification(0); // Only fetch on initial load
  }, []); // Only run once on mount

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Don't reset page on refresh - keep current page
      fetchNotification(currentPage, false);
    }, 60000);
  
    return () => clearInterval(intervalId);
  }, [currentPage]); // Separate effect for interval
  
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleMarkAllAsRead = async() => {
    console.log("####################ffffffffffff");
    let res = await axios.post(`${REST_API_END_POINT}notifications/update-notifications`,{userId:userData.user_id})
    setNotifications(res.data.notifications)
    setNotificationCount(res.data["notificationCount"]["noti_count"])
    // Reset pagination state after marking all as read
    setCurrentPage(0)
    setTotalCount(0)
  };

  return (
    <>
      <MIconButton
        ref={anchorRef}
        onClick={handleOpen}
        color={open ? 'primary' : 'default'}
        sx={{
          ...(open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <Badge badgeContent={notificationCount} color="error">
          <Icon icon={bellFill} width={20} height={20} />
        </Badge>
      </MIconButton>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 360 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" >
              You have {notificationCount} unread messages
            </Typography>
          </Box>

          {/* {notificationCount > 0 && ( */}
            <Tooltip title=" Mark all as read">
              <MIconButton color="primary" onClick={()=>handleMarkAllAsRead()}>
                <Icon icon={doneAllFill} width={20} height={20} />
              </MIconButton>
            </Tooltip>
          {/* )} */}
        </Box>

        <Divider />

        <Scrollbar sx={{ maxHeight: 400, maxWidth: 500 }}>
          <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                New
              </ListSubheader>
            }
          >
            {/* {notifications.slice(0, 2).map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))} */}
            {notifications?.map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List>
{/* 
          <List
            disablePadding
            subheader={
              <ListSubheader disableSticky sx={{ py: 1, px: 2.5, typography: 'overline' }}>
                Before that
              </ListSubheader>
            }
          >
            {notifications.slice(2, 5).map((notification) => (
              <NotificationItem key={notification.id} notification={notification} />
            ))}
          </List> */}
        </Scrollbar>

        {/* TablePagination Component */}
        {notifications && notifications.length > 0 && (
          <>
          <Divider />
          <TablePagination
            component="div"
            count={totalCount}
            page={currentPage}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[6]} // Fixed at 6 items per page
            labelRowsPerPage=""
            labelDisplayedRows={({ from, to, count }) => 
              `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
            }
            sx={{
              // borderTop: '1px solid #e0e0e0',
              '& .MuiTablePagination-toolbar': {
                paddingLeft: 2,
                paddingRight: 2,
                minHeight: '48px'
              },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                fontSize: '0.875rem'
              }
            }}
          />
          </>
        )}

        {/* <Divider /> */}

        {/* <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple component={RouterLink} to="#">
            View All
          </Button>
        </Box> */}
      </MenuPopover>
    </>
  );
}
